export default "__VITE_ASSET__0be3833d__"